// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  pageWrapper: {
    width: 1200,
    margin: '0 auto',
  },
  icons: {
    flexGrow: 0,
  },
  itemsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  orderAdjustmentsWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  orderAdjustmentsItemCard: {
    padding: theme.spacing(2),
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E5E5',
    borderRadius: theme.spacing(1),
    boxShadow: '4px 6px 8px 0px #00000017',
    marginBottom: theme.spacing(2),
  },
  orderAdjustmentsItemCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  noTransformText: {
    textTransform: 'none',
  },
  orderAdjustmentsItemCardTitleSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  projectNameText: {
    fontWeight: 600,
    fontSize: '18px',
    marginRight: theme.spacing(2),
  },
  orderAdjustmentsItemCardContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
    marginBottom: theme.spacing(2),
  },
  orderAdjustmentsItemCardContentItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    borderRight: '2px solid #E5E5E5',
    width: '100%',
    paddingLeft: theme.spacing(2),
    '&:last-child': {
      borderRight: 'none',
    },
    '&:first-child': {
      paddingLeft: '0px',
    },
  },
  orderAdjustmentsItemCardContentItemBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  labelText: {
    fontWeight: 600,
    marginRight: theme.spacing(1),
  },
  reasonSection: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    // padding: theme.spacing(2, 2, 2, 0),
  },
  valueText: {
    fontWeight: 400,
    fontSize: '14px',
  },
  viewAllAdjustmentsSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  noOrderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '150px',
    gap: theme.spacing(2),
  },
});

export default styles;
